export default {
	'inquiry.title': '询盘留言管理',
	'inquiry.inquiries': '询盘管理',
	'inquiry.messages': '留言管理',
	'inquiry.subscriptions': '订阅管理',
	'inquiry.detail': '详情查看',
	'inquiry.list.id': 'ID',
	'inquiry.list.name': '姓名',
	'inquiry.list.phone': '联系电话',
	'inquiry.list.email': '邮箱地址',
	'inquiry.list.product': '关联产品',
	'inquiry.list.content': '内容',
	'inquiry.list.ip_address': 'IP地址',
	'inquiry.list.status': '状态',
	'inquiry.list.created_at': '提交时间',
	'inquiry.list.updated_at': '更新时间',
	'inquiry.list.actions': '操作',
	'inquiry.status.read': '已读',
	'inquiry.status.unread': '未读',
	'inquiry.search.name': '请输入姓名',
	'inquiry.search.email': '请输入邮箱',
	'inquiry.search.phone': '请输入电话',
	'inquiry.search.product': '请选择产品',
	'inquiry.search.status': '请选择状态',
	'inquiry.search.date_range': '选择时间范围',
	'inquiry.actions.view': '查看',
	'inquiry.actions.delete': '删除',
	'inquiry.actions.batch_delete': '批量删除',
	'inquiry.actions.mark_read': '标记已读',
	'inquiry.actions.export': '导出',
	'inquiry.confirm.delete': '确认删除',
	'inquiry.confirm.delete_content': '确定要删除这条记录吗？',
	'inquiry.confirm.batch_delete': '确认批量删除',
	'inquiry.confirm.batch_delete_content': '确定要删除选中的记录吗？',
	'inquiry.message.delete_success': '删除成功',
	'inquiry.message.delete_failed': '删除失败',
	'inquiry.message.mark_read_success': '标记已读成功',
	'inquiry.message.mark_read_failed': '标记已读失败',
	'inquiry.message.fetch_failed': '获取数据失败',
	'inquiry.detail.info': '基本信息',
	'inquiry.detail.content': '内容详情',
	'inquiry.detail.back': '返回',
	'inquiry.detail.not_found': '数据不存在',
	'inquiry.category.inquiry': '询盘',
	'inquiry.category.message': '留言'
};
